import { render, staticRenderFns } from "./confirmation_dialog.vue?vue&type=template&id=435c4abe&lang=pug"
import script from "./confirmation_dialog.vue?vue&type=script&lang=js"
export * from "./confirmation_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports